import Profile from "../components/users/userProfile/UserProfile";

const UserProfile = () => {
  return (
    <div className="profile-page">
      <Profile />
    </div>
  );
};
export default UserProfile;